import { render } from "./TradingVolumeChart.vue?vue&type=template&id=e71be456&ts=true"
import script from "./TradingVolumeChart.vue?vue&type=script&lang=ts"
export * from "./TradingVolumeChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__